// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import NoResultsImg from '../images/no-results.svg';

function NoResults() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', paddingTop: '50px'
    }}
    >
      <img style={{ width: '250px', height: '250px', objectFit: 'cover' }} src={NoResultsImg} alt="No Results!" />
      <p style={{ textAlign: 'center', marginTop: '1rem' }}>Not Found!</p>
    </div>
  );
}

export default NoResults;
